import { AfterViewInit, Component, ElementRef, Input, ViewChild } from '@angular/core';

@Component({
  standalone: false,
  template: `
    <nb-progress-bar #bar [value]="data.value" [displayValue]="true" [status]="data.status" [nbTooltipDisabled]="!data || !data.tooltip"
      [nbTooltip]="data.tooltip" nbTooltipStatus="default" nbTooltipPlacement="bottom">
    </nb-progress-bar>
  `,
  styleUrls: ['./progress-bar-cell.component.scss'],
})
export class ProgressBarCellComponent implements AfterViewInit {
  @Input()
  data: any;
  @ViewChild('bar', { read: ElementRef }) progressBarRef!: ElementRef;

  constructor() { }

  ngAfterViewInit(): void {
    if (this.data.label) {
      // in this case we remove the default percentage value by the label passed
      const textContainer = this.progressBarRef.nativeElement.querySelector('.progress-value span');
      if (textContainer) {
        textContainer.innerHTML = this.data.value + '%<b class="date">(' + this.data.label + ')</b>';
      }
    }
  }
}
